module.exports = __webpack_public_path__ + "img/history.58d9f5cb.svg";